<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex">
        <v-select
          v-model="property.operation"
          label="Operation"
          :items="operations"
          item-text="label"
          item-value="key"
          class="width100px"
          dense
          hide-details
        ></v-select>

        <!-- multiple fields -->
        <v-select
          v-if="property.operation === 'clear'"
          v-model="property.fields"
          label="Fields"
          :items="fields"
          item-text="name"
          item-value="_id"
          class="m-l-10"
          dense
          hide-details
          multiple
          chips
          clearable
          clear-icon="fa-times"
          @change="setFieldsName"
        >
          <template v-slot:selection="data">
            <v-tooltip
              v-if="data.item.description"
              :max-width="350"
              :open-delay="700"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-on="on" v-bind="attrs">{{ data.item.name }}</v-chip>
              </template>
              <div class="text-block">{{ data.item.description }}</div>
            </v-tooltip>
            <v-chip v-else>
              {{ data.item.name }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <v-tooltip
              v-if="data.item.description"
              :max-width="350"
              :open-delay="700"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-layout wrap v-on="on" v-bind="attrs">
                  <v-list-item-action class="m-r-10">
                    <v-checkbox v-model="data.attrs.inputValue" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-layout>
              </template>
              <div class="text-block">{{ data.item.description }}</div>
            </v-tooltip>
            <v-layout v-else wrap>
              <v-list-item-action class="m-r-10">
                <v-checkbox v-model="data.attrs.inputValue" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-layout>
          </template>
        </v-select>

        <!-- single field -->
        <v-select
          v-else
          v-model="property.field_id"
          label="Field"
          :items="fields"
          item-text="name"
          item-value="_id"
          class="m-l-10"
          dense
          hide-details
          @change="setFieldName"
        >
          <template v-slot:selection="data">
            <v-tooltip
              v-if="data.item.description"
              :max-width="350"
              :open-delay="700"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs">{{ data.item.name }}</div>
              </template>
              <div class="text-block">{{ data.item.description }}</div>
            </v-tooltip>
            <div v-else>{{ data.item.name }}</div>
          </template>
          <template v-slot:item="data">
            <v-tooltip
              v-if="data.item.description"
              :max-width="350"
              :open-delay="700"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-layout wrap v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-layout>
              </template>
              <div class="text-block">{{ data.item.description }}</div>
            </v-tooltip>
            <v-layout v-else wrap>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-layout>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <div v-for="(operation, index) in operations" :key="index">
      <v-row
        v-if="
          operation.key === property.operation &&
            property.operation !== 'lookup' &&
            property.operation !== 'clear'
        "
      >
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            :id="`text${operation.key}`"
            v-model="operation.value"
            :label="operation.title"
            :type="
              ['increase', 'decrease'].includes(property.operation)
                ? 'number'
                : 'text'
            "
            class="no-margin-top"
            @keyup="updateOpertion(`text${operation.value}`)"
            @blur="blurOpertion(operation)"
            dense
            hide-details
            @keyup.down="pressDown"
            @keyup.up="pressUp"
            @keydown.enter="onEnter"
            @keydown.tab="pressTab"
          ></v-text-field>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            v-if="operation.key !== 'increase' && operation.key !== 'decrease'"
            :input="operation.value"
            :drawFlowItems="drawFlowItems"
            :property="'value'"
            @updateIntellisense="updateIntellisense"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>
      </v-row>

      <v-row
        v-if="
          operation.key === property.operation &&
            property.operation === 'lookup'
        "
      >
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            v-model="property.searching_key"
            :label="operation.title"
            type="text"
            class="no-margin-top"
            dense
            hide-details
            @keyup.down="pressDown"
            @keyup.up="pressUp"
            @keydown.enter="onEnter"
            @keydown.tab="pressTab"
          ></v-text-field>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            v-if="operation.key !== 'increase' && operation.key !== 'decrease'"
            :input="property.searching_key"
            :drawFlowItems="drawFlowItems"
            :property="'searching_key'"
            @updateIntellisense="updateIntellisense"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <v-select
            v-model="property.lookup_table_id"
            :items="lookuptables"
            item-text="table_name"
            item-value="lookup_table_id"
            :label="operation.title2"
            hide-details
            clearable
            clear-icon="fa-times"
          >
          </v-select>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            v-model="property.column_index"
            :label="operation.title3"
            type="text"
            class="no-margin-top"
            dense
            hide-details
          ></v-text-field>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            :input="property.column_index"
            :drawFlowItems="drawFlowItems"
            :property="'column_index'"
            @updateIntellisense="updateIntellisense"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            v-model="property.default_value"
            :label="operation.title4"
            type="text"
            class="no-margin-top"
            dense
            hide-details
            @keyup.down="pressDown"
            @keyup.up="pressUp"
            @keydown.enter="onEnter"
            @keydown.tab="pressTab"
          ></v-text-field>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            v-if="operation.key !== 'increase' && operation.key !== 'decrease'"
            :input="property.default_value"
            :drawFlowItems="drawFlowItems"
            :property="'default_value'"
            :apiForIntellisense="apiForIntellisense"
            @updateIntellisense="updateIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>
      </v-row>
    </div>
    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'
import apiField from '@/apis/field'
import apiLookupTables from '@/apis/lookup_tables'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      fields: [],
      lookuptables: [],
      operations: [
        {
          label: 'Clear',
          key: 'clear',
          title: '',
          value: ''
        },
        {
          label: 'Set',
          key: 'value',
          title: 'To value',
          value: ''
        },
        {
          label: 'Prepend',
          key: 'prepend',
          title: 'With',
          value: ''
        },
        {
          label: 'Append',
          key: 'append',
          title: 'With',
          value: ''
        },
        {
          label: 'Increase',
          key: 'increase',
          title: 'By',
          value: 1
        },
        {
          label: 'Decrease',
          key: 'decrease',
          title: 'By',
          value: 1
        },
        {
          label: 'Lookup',
          key: 'lookup',
          title: 'By searching for key',
          title2: 'From lookup table',
          title3:
            'Return the value from column index (starting from 1), column name, or entire row (enter 0)',
          title4: 'If key is not found, return default value',
          value: ''
        }
      ],
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  watch: {
    'property.operation': {
      handler(val) {
        const findIndex = _.findIndex(this.operations, {
          key: val
        })

        if (findIndex > -1) {
          this.property.value = this.operations[findIndex].value
        }
      }
    },
    'property.lookup_table_id': {
      handler(value) {
        if (value) {
          const lookupTable = _.find(this.lookuptables, {
            lookup_table_id: value
          })
          if (lookupTable)
            this.property.lookup_table_name = lookupTable.table_name
        }
      }
    }
  },
  created() {
    this.property = this.node.property
    if (!this.property.operation) this.property.operation = 'value'

    const findIndex = _.findIndex(this.operations, {
      key: this.property.operation
    })

    if (findIndex > -1) {
      this.operations[findIndex].value = this.property.value
    }

    if (typeof this.property.field_id === 'undefined') {
      this.property.field_id = ''
      if (typeof this.property.field_name === 'undefined') {
        this.property.field_name = ''
      }
    }
    if (typeof this.property.fields === 'undefined') {
      this.property.fields = []
      if (typeof this.property.fields_name === 'undefined') {
        this.property.fields_name = []
      }
    }

    // change column_index => intellisense
    if (typeof this.property.column_index === 'number') {
      this.property.column_index = this.property.column_index.toString()
    }

    this.initial()
  },
  methods: {
    async initial() {
      await this.getField()
      await this.getLookupTablesList()
      this.validateField()
    },
    async getField() {
      try {
        const getField = await apiField.activeField()
        const { data } = getField

        this.fields = []
        for (const obj of data) {
          this.fields.push({
            _id: obj._id,
            name: `${obj.group}.${obj.name}`,
            description: obj.description
          })
        }
      } catch {}
    },
    clickOperation(ref) {
      const id = document.getElementById(ref)

      if (id) {
        this.property.value = id.value

        setTimeout(() => {
          id.focus()
        }, 100)
      }
    },
    blurOpertion(operation) {
      if (['increase', 'decrease'].includes(operation.key)) {
        const num = Number(operation.value)
        operation.value = isNaN(num) ? 0 : Math.abs(num)
      }
      this.property.value = operation.value
    },
    updateOpertion(ref) {
      const id = document.getElementById(ref)

      if (id) {
        this.property.value = id.value
      }
    },
    async getLookupTablesList() {
      try {
        const getLookupTablesList = await apiLookupTables.getLookupTablesList()
        const { data } = getLookupTablesList

        this.lookuptables = []
        for (const obj of data) {
          this.lookuptables.push({
            lookup_table_id: obj.lookup_table_id,
            table_name: obj.table_name
          })
        }
      } catch {}
    },
    // blurColumnIndex() {
    //   if (isNaN(parseInt(this.property.column_index))) {
    //     this.property.column_index = 1
    //   } else if (parseInt(this.property.column_index) <= 0) {
    //     this.property.column_index = 1
    //   } else if (parseInt(this.property.column_index) > 16384) {
    //     this.property.column_index = 1
    //   } else {
    //     this.property.column_index = parseInt(this.property.column_index)
    //   }
    // },
    setFieldName() {
      this.property.field_name = ''
      const data = _.find(this.fields, { _id: this.property.field_id })
      if (data) this.property.field_name = data.name
    },
    setFieldsName() {
      this.property.fields_name = []
      this.property.fields.forEach(id => {
        const data = _.find(this.fields, { _id: id })
        if (data) this.property.fields_name.push(data.name)
      })
    },
    validateField() {
      if (this.fields.length) {
        if (
          [
            'value',
            'prepend',
            'append',
            'increase',
            'decrease',
            'lookup'
          ].includes(this.property.operation)
        ) {
          const data = _.find(this.fields, { _id: this.property.field_id })
          if (!data) {
            this.property.field_id = undefined
            this.property.field_name = undefined
          }
        } else if (this.property.operation === 'clear') {
          const tmp_ids = []
          const tmp_names = []
          this.property.fields.forEach(id => {
            const data = _.find(this.fields, { _id: id })
            if (data) {
              tmp_ids.push(data._id)
              tmp_names.push(data.name)
            }
          })
          this.property.fields = tmp_ids
          this.property.fields_name = tmp_names
        }
      }
      if (this.lookuptables.length) {
        if (this.property.operation === 'lookup') {
          const data = _.find(this.lookuptables, {
            lookup_table_id: this.property.lookup_table_id
          })
          if (!data) {
            this.property.lookup_table_id = undefined
            this.property.lookup_table_name = undefined
          }
        }
      }
    },
    // === use for Intellisense ===
    updateIntellisense(data) {
      this.node.property.value = '$' + data
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter() {
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      const index = this.operations.findIndex(
        operation => operation.key === this.property.operation
      )
      if (property == 'value') {
        this.operations[index].value = data
      } else if (property == 'searching_key') {
        this.property.searching_key = data
      } else if (property == 'default_value') {
        this.property.default_value = data
      } else if (property == 'column_index') {
        this.property.column_index = data
      }
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.width100px {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}
.margin-radio {
  margin-top: 10px;
}

.description {
  word-wrap: break-word;
}
.width90px {
  width: 90px;
  min-width: 90px;
  .v-input {
    margin-bottom: -8px;
  }
}

.text-block {
  white-space: pre-line;
  word-wrap: break-word;
}

::v-deep .v-input__icon.v-input__icon--clear {
  width: 16px;
  min-width: 16px;
  height: 16px;
  .v-icon.v-icon {
    font-size: 16px !important;
    margin-top: 18px !important;
  }
}

::v-deep .v-select.v-input--dense {
  .v-chip {
    margin: 2px 4px 0 4px;
  }
  .v-select__selections {
    min-height: 25px !important;
  }
}

::v-deep .v-chip.v-size--default {
  font-size: 12px;
  height: 22px;
}
</style>
